import { SnipTestAcceptabilitySummary } from '../../../PulmonaryFunctionTests/Shared/PFTAPITypes';
import { TestResults } from '../../../PulmonaryFunctionTests/Shared/PFTAPITypes';
import { ParameterTypeName } from '../ParameterTypes';

export function MapSnipTestAcceptabilitySummaries(testResults: TestResults[]): Array<SnipTestAcceptabilitySummary> {
    return testResults.map(tr => {
        return {
            Accepted: tr.OverreaderAcceptability,
            TestId: tr.TestId,
            Snip: tr.TestParameters.find(tp => tp.ParameterType == ParameterTypeName.PARAM_SNIP).Value,
        } as SnipTestAcceptabilitySummary;
    });
}
